import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"450px","height":"400px"} }
const _hoisted_5 = {
  key: 0,
  class: "p-field"
}
const _hoisted_6 = {
  class: "p-field-label",
  for: "apartmentname"
}
const _hoisted_7 = {
  for: "apartmentname",
  class: "fs-13 label-error"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-items-start"
}
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = { class: "p-field-label" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = { class: "p-field-label" }
const _hoisted_13 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.isEdit || _ctx.isBrfa)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.inputLabel), 1),
                _createVNode(_component_InputText, {
                  disabled: _ctx.isBrfa,
                  id: "apartmentname",
                  type: "text",
                  class: ["w-100", { 'input-error': !_ctx.isValidName }],
                  modelValue: _ctx.apartment.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apartment.name = $event))
                }, null, 8, ["disabled", "modelValue", "class"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.invalidNameReason), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isEdit && !_ctx.isBrfa)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("label", null, _toDisplayString(_ctx.$t("AppResourceEP.ChooseApartmentsToAdd")), 1),
                _createVNode(_component_NumberButtons, {
                  class: "ml-auto",
                  modelValue: _ctx.newApartments,
                  "min-value": 1,
                  "max-value": _ctx.availableApartments,
                  onIncrement: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newApartments++)),
                  onDecrement: _cache[3] || (_cache[3] = ($event: any) => (_ctx.newApartments--))
                }, null, 8, ["modelValue", "max-value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isBrfa)
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                  _createVNode(_component_Dropdown, {
                    class: "w-100",
                    options: _ctx.building.risers,
                    disabled: _ctx.building.risers && _ctx.building.risers.length === 1,
                    optionLabel: "name",
                    modelValue: _ctx.selectedRiser,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedRiser = $event)),
                      _ctx.updateApartment
                    ]
                  }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResourceEP.Floor")), 1),
                  _createVNode(_component_Dropdown, {
                    class: "w-100",
                    options: _ctx.riserFloors,
                    disabled: _ctx.riserFloors.length === 1,
                    optionLabel: "floor.name",
                    optionValue: "floor.floorId",
                    modelValue: _ctx.apartment.floorId,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => (_ctx.apartment.floorId = $event)),
                      _ctx.updateApartment
                    ]
                  }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("footer", _hoisted_13, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.buttonSubmitLabel,
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m",
          disabled: _ctx.saveButtonDisabled
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}